import React, { useRef, useState } from "react";
import JoditEditor from "jodit-react";
import "./Blogpost.css";

const Blogpost = ({ categories }) => {
    const editor = useRef(null);
    const [post, setPost] = useState({ title: "", content: "", categoryId: 0 });
    const [image, setImage] = useState(null);

    const fieldChanged = (event) => {
        setPost({ ...post, [event.target.name]: event.target.value });
        console.log(event.target.value)
    };

    const contentFieldChanged = (newContent) => {
        setPost({ ...post, content: newContent });
    };

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    const createPost = (event) => {
        event.preventDefault();
        console.log("Post Submitted", post, image);
    };

    return (
        <div className="wrapper">
            <div className="card">
                <div className="card-body">
                
                    <h3>What’s going on in your mind?</h3>
                    <form onSubmit={createPost}>
                        <div className="form-group">
                            <label htmlFor="title">Post Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Enter here"
                                onChange={fieldChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="content">Post Content</label>
                            <JoditEditor ref={editor} value={post.content} onChange={contentFieldChanged} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="image">Select Post Banner</label>
                            <input type="file" id="image" onChange={handleFileChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="category">Post Category</label>
                            <input type="text"
                             id="category"
                              name="category"
                               placeholder="Enter here"
                                onChange={fieldChanged} 
                                 />
                        </div>
                        <div className="button-container">
                            <button type="submit" className="primary-btn">Create Post</button>
                            <button type="reset" className="danger-btn">Reset Content</button>
                        </div>
                    </form>
                </div>
            </div>
            </div>
  );
}
export default Blogpost;
